import Component from '../core/Component'

const STATES = {
    ACTIVE: 'is-active',
    VISIBLE: 'is-visible'
}

export default class CartBox extends Component {
    prepare() {
        this.element.addEventListener('mouseenter', this.handleMouseEnter)
        this.element.addEventListener('mouseleave', this.handleMouseLeave)
    }

    destroy() {
        document.removeEventListener('click', this.handleClick)
        clearTimeout(this.timer)
    }

    handleMouseEnter = event => {
        this.show()
    }

    handleMouseLeave = event => {
        this.hide()
    }

    handleClick = event => {
        if (this.element.contains(event.target)) {
            return
        }
    }

    show({x,y,width,height,viewType} = {}) {
        clearTimeout(this.timer)
        if (!this.is(STATES.VISIBLE)) {
            this.element.classList.add(STATES.VISIBLE)
            this.element.offsetWidth
            this.element.classList.add(STATES.ACTIVE)
            document.addEventListener('click', this.handleClick)
        }

        if (x && y) {
            this.updatePosition(this.getCalculatedPosition({x,y,width,height}))
        }

        if (viewType) {
            this.element.classList.forEach(className => {
                if (className.startsWith('is-viewtype-')) {
                    this.element.classList.remove(className)
                }
            })
            this.element.classList.add(`is-viewtype-${viewType}`)
        }

    }

    hide() {
        document.removeEventListener('click', this.handleClick)

        this.timer = setTimeout(() => {
            this.element.classList.remove(STATES.ACTIVE)
            this.element.classList.remove(STATES.VISIBLE)
        }, 200)
    }

    getCalculatedPosition({x, y, width = 0, height = 0} = {}) {
        const rect = this.element.getBoundingClientRect()
        const delta =  (x + rect.width + 20) - window.innerWidth
        if (delta > 0) {
            x -= delta
        }

        if (x < 0) {
            x = 0
        }

        return {
            x,
            y: y + height - 0
        }
    }

    updatePosition({x,y}) {
        this.element.style.left = `${x}px`
        this.element.style.top = `${y}px`
    }
}